module.exports = __webpack_public_path__ + "img/img.6be956a8.png";